import styled from "styled-components";

export const Styled = styled.div`
  height: calc(100% - 10px);
  display: flex;
  align-items: center;
  justify-content: center;
`;
